import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import Modal from 'react-native-modal';
import { Button, Text } from '~/components';
import CloseSVG from '~/assets/svgs/close.svg';
import DoorLeaveSVG from '~/assets/svgs/door-leave.svg';
import colors from '~/assets/themes/colors';
import { twMerge } from 'tailwind-merge';
import useAppNavigation from '~/hooks/useAppNavigation';
import { isWeb } from '~/utils/device';

interface Props {
  visible: boolean;
  onDismiss: () => void;
}

const ExitConfirmationModal: React.FC<Props> = ({ visible, onDismiss }) => {
  const { navigate } = useAppNavigation();

  return (
    <Modal
      isVisible={visible}
      onBackdropPress={onDismiss}
      onBackButtonPress={onDismiss}
      className={isWeb ? 'items-center justify-center' : ''}
    >
      <View className={twMerge('bg-light-100 p-4 rounded-2xl')}>
        <TouchableOpacity className="self-end" onPress={onDismiss}>
          <CloseSVG width={24} height={24} color={colors.gray[400]} />
        </TouchableOpacity>
        <View className="items-center justify-center">
          <View className="rounded-full bg-feedback-neutral-bkg p-4 mb-6">
            <DoorLeaveSVG
              color={colors.secondary[800]}
              width={38}
              height={38}
            />
          </View>
          <Text className="text-center leading-6 text-base mb-6">
            Deseja sair da contratação da Assistência Marisa Cuida?
          </Text>
          <Button className="w-full mb-6" onPress={onDismiss}>
            Continuar a Contratação
          </Button>

          <Button
            variant="tertiary"
            onPress={() => {
              onDismiss();
              navigate('MarisaServicos_Home');
            }}
          >
            IR PARA A HOME MARISA SERVIÇOS
          </Button>
        </View>
      </View>
    </Modal>
  );
};

export default ExitConfirmationModal;
